module.exports = __webpack_public_path__ + "img/召陵区.c0857634.png";